export interface BrowserSpeechRecognitionResultEntry {
  readonly transcript: string
}

export interface BrowserSpeechRecognitionEvent {
  readonly results: ArrayLike<ArrayLike<BrowserSpeechRecognitionResultEntry>>
}

export interface BrowserSpeechRecognition {
  continuous: boolean
  interimResults: boolean
  lang: string
  onend: null | (() => void)
  onerror: null | ((event: { readonly error?: string }) => void)
  onresult: null | ((event: BrowserSpeechRecognitionEvent) => void)
  start: () => void
  stop: () => void
}

export interface BrowserSpeechRecognitionConstructor {
  new (): BrowserSpeechRecognition
}

export function getSpeechRecognitionConstructor() {
  if (typeof window === 'undefined') {
    return null
  }

  const browserWindow = window as typeof window & {
    readonly SpeechRecognition?: BrowserSpeechRecognitionConstructor
    readonly webkitSpeechRecognition?: BrowserSpeechRecognitionConstructor
  }

  return browserWindow.SpeechRecognition ?? browserWindow.webkitSpeechRecognition ?? null
}

export function hasSpeechRecognitionSupport() {
  return Boolean(getSpeechRecognitionConstructor())
}
